import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=572a2fcc&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style1 from "./Index.vue?vue&type=style&index=1&id=572a2fcc&prod&lang=scss"
import style2 from "./Index.vue?vue&type=style&index=2&id=572a2fcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572a2fcc",
  null
  
)

export default component.exports